import { render, staticRenderFns } from "./GoodsTag.vue?vue&type=template&id=40cec382&scoped=true"
import script from "./GoodsTag.vue?vue&type=script&lang=js"
export * from "./GoodsTag.vue?vue&type=script&lang=js"
import style0 from "./GoodsTag.vue?vue&type=style&index=0&id=40cec382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cec382",
  null
  
)

export default component.exports